export default __webpack_public_path__ + "static/SharpSans-Bold-aa00a9ddc5c9fefd684cf310ca174e3e.otf";